<div class="settings-widget sidebar-content">
  <div class="settings-header d-sm-flex flex-row flex-wrap text-center text-sm-start align-items-center">
    <div class="sidebar-content__user">
      <a [routerLink]="'/home'" (click)="handleNavigate()">
        <img src="assets/img/Mercado-cheque-white.png" class="img-fluid" alt="Logo" style="width: 80%;">
      </a>
    </div>
  </div>

  <div class="settings-menu sidebar-menu-layout">
    <ul class="sidebar-menu sidebar-menu--top">
      <li class="nav-item">
        <a [routerLink]="'/home'" class="nav-link" routerLinkActive="active" (click)="handleNavigate()">
          <hugeicons-icon [icon]="Home09Icon" color="#ffffff" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
          Inicio
        </a>
      </li>

      <li class="nav-item">
        <a class="nav-link text-truncate cursor-pointer sidebar-menu__toggle" routerLinkActive="active" (click)="toggleChecksMenu()">
          <div>
            <hugeicons-icon [icon]="PayByCheckIcon" color="#ffffff" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
            Cheques
          </div>
          <hugeicons-icon [icon]="ArrowRight01Icon" color="#fff" [size]="20" [strokeWidth]="2" class="arrows-container" [ngClass]="{'rotate': !isChecksNavbarCollapsed || isChecksSubmenuActive()}"></hugeicons-icon>
        </a>

        <div class="collapse navbar-collapse sidebar-submenu-collapse" [ngbCollapse]="isChecksNavbarCollapsed && !isChecksSubmenuActive()">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <a [routerLink]="'/descontar'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Vender</span>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="'/invertir/cheques'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Comprar</span>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="'/portfolio'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Cartera</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li class="nav-item">
        <a class="nav-link text-truncate cursor-pointer sidebar-menu__toggle" routerLinkActive="active" (click)="toggleFinancingMenu()">
          <div>
            <hugeicons-icon [icon]="CoinsDollarIcon" color="#ffffff" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
            <span>Financiamiento</span>
          </div>
          <hugeicons-icon [icon]="ArrowRight01Icon" color="#fff" [size]="20" [strokeWidth]="2" class="arrows-container" [ngClass]="{'rotate': !isFinancingNavbarCollapsed || isFinancingSubmenuActive()}"></hugeicons-icon>
        </a>

        <div class="collapse navbar-collapse sidebar-submenu-collapse" [ngbCollapse]="isFinancingNavbarCollapsed && !isFinancingSubmenuActive()">
          <ul class="navbar-nav mr-auto">
            <li
              class="nav-item"
              *ngIf="(accountStatus$ | async)?.financialStatus && (accountStatus$ | async)?.financialStatus != financialStatus.DENIED_FOR_REQUEST">
              <a [routerLink]="'/perfil-publico/nueva-solicitud'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Solicitar Financiamiento</span>
              </a>
            </li>
            <li
              class="nav-item"
              *ngIf="(accountStatus$ | async)?.financialStatus && (accountStatus$ | async)?.financialStatus != financialStatus.DENIED_FOR_REQUEST">
              <a [routerLink]="'/perfil-publico/mis-pedidos'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Mis Solicitudes</span>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="'/invertir/lineas-credito'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Financiar</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li class="nav-item">
        <a class="nav-link text-truncate cursor-pointer sidebar-menu__toggle" routerLinkActive="active" (click)="toggleOffersMenu()">
          <div>
            <hugeicons-icon [icon]="AuctionIcon" color="#ffffff" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
            <span>Ofertas</span>
          </div>
          <hugeicons-icon [icon]="ArrowRight01Icon" color="#fff" [size]="20" [strokeWidth]="2" class="arrows-container" [ngClass]="{'rotate': !isOffersNavbarCollapsed || isOffersSubmenuActive()}"></hugeicons-icon>
        </a>

        <div class="collapse navbar-collapse sidebar-submenu-collapse" [ngbCollapse]="isOffersNavbarCollapsed && !isOffersSubmenuActive()">
          <ul class="navbar-nav mr-auto">
            <li
              class="nav-item">
              <a [routerLink]="'/ofertas'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Cheques</span>
              </a>
            </li>
            <li class="nav-item">
              <a routerLink="/perfil-publico/ofertas" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Financiamiento</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li class="nav-item">
        <a class="nav-link text-truncate cursor-pointer sidebar-menu__toggle" routerLinkActive="active" (click)="toggleChatMenu()">
          <div>
            <hugeicons-icon [icon]="Chat01Icon" color="#ffffff" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
            <span>Chat</span>
            <div *ngIf="((hasUnread$ | async)?.mensajes || (hasUnread$ | async)?.preguntas) && isChatNavbarCollapsed && !isChatSubmenuActive()" class="unread-mark"></div>
          </div>
          <hugeicons-icon [icon]="ArrowRight01Icon" color="#fff" [size]="20" [strokeWidth]="2" class="arrows-container" [ngClass]="{'rotate': !isChatNavbarCollapsed || isChatSubmenuActive()}"></hugeicons-icon>
        </a>

        <div class="collapse navbar-collapse sidebar-submenu-collapse" [ngbCollapse]="isChatNavbarCollapsed && !isChatSubmenuActive()">
          <ul class="navbar-nav mr-auto">
            <li
              class="nav-item">
              <a [routerLink]="'/perfil-publico/mis-negociaciones'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Conversaciones</span>
                <div *ngIf="(hasUnread$ | async)?.mensajes && (!isChatNavbarCollapsed || isChatSubmenuActive())" class="unread-mark"></div>
              </a>
            </li>
            <li class="nav-item">
              <a routerLink="/perfil-publico/mis-preguntas" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Preguntas Públicas</span>
                <div *ngIf="(hasUnread$ | async)?.preguntas && (!isChatNavbarCollapsed || isChatSubmenuActive())" class="unread-mark"></div>
              </a>
            </li>
          </ul>
        </div>
      </li>
      
      <li class="nav-item">
        <a class="nav-link text-truncate cursor-pointer sidebar-menu__toggle" routerLinkActive="active" (click)="toggleOperationsMenu()">
          <div>
            <hugeicons-icon [icon]="ChartRoseIcon" color="#ffffff" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
            <span>Operaciones</span>
          </div>
          <hugeicons-icon [icon]="ArrowRight01Icon" color="#fff" [size]="20" [strokeWidth]="2" class="arrows-container" [ngClass]="{'rotate': !isOperationsNavbarCollapsed || isOperationsSubmenuActive()}"></hugeicons-icon>
        </a>

        <div class="collapse navbar-collapse sidebar-submenu-collapse" [ngbCollapse]="isOperationsNavbarCollapsed && !isOperationsSubmenuActive()">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <a [routerLink]="'/dashboard'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Mi Posición</span>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="'/transaccion-list'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Mis Operaciones</span>
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li class="nav-item">
        <a [routerLink]="'/instructive'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
          <hugeicons-icon [icon]="BookOpenTextIcon" color="#ffffff" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
          Instructivos
        </a>
      </li>
    </ul>

    <ul class="sidebar-menu sidebar-menu--bottom">
      <li class="nav-item">
        <a
          class="nav-link text-truncate cursor-pointer sidebar-menu__toggle"
          routerLinkActive="active"
          (click)="toggleAccountMenu()">
          <div>
            <hugeicons-icon [icon]="UserIcon" color="#ffffff" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
            <span>Perfil</span>
          </div>
          <hugeicons-icon [icon]="ArrowRight01Icon" color="#fff" [size]="20" [strokeWidth]="2" class="arrows-container" [ngClass]="{'rotate': !isAccountNavbarCollapsed || isProfileSubmenuActive()}"></hugeicons-icon>
        </a>

        <div class="collapse navbar-collapse sidebar-submenu-collapse" [ngbCollapse]="isAccountNavbarCollapsed && !isProfileSubmenuActive()">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <a [routerLink]="'/user-account-details'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Mi Perfil</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="(accountStatus$ | async)?.financialStatus == financialStatus.ENABLED_FOR_REQUEST">
              <a [routerLink]="'/perfil-publico/mi-perfil-publico'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                <span>Mi Perfil Público</span>
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="'/mi-documentacion'" class="nav-link" routerLinkActive="active" (click)="handleNavigate()">
                Mi Documentación
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="'/recibos-facturas'" class="nav-link" routerLinkActive="active" (click)="handleNavigate()">
                Mis Recibos y Facturas
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="'/referral'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                Referidos
              </a>
            </li>
          </ul>
        </div>
      </li>

      <li class="nav-item">
        <a
          class="nav-link text-truncate cursor-pointer sidebar-menu__toggle"
          routerLinkActive="active"
          (click)="toggleAboutMenu()">
          <div>
            <hugeicons-icon [icon]="BadgeInfoIcon" color="#ffffff" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
            <span>Sobre Mercado Cheque</span>
          </div>
          <hugeicons-icon [icon]="ArrowRight01Icon" color="#fff" [size]="20" [strokeWidth]="2" class="arrows-container" [ngClass]="{'rotate': !isAboutNavbarCollapsed || isAboutSubmenuActive()}"></hugeicons-icon>
        </a>

        <div class="collapse navbar-collapse sidebar-submenu-collapse" [ngbCollapse]="isAboutNavbarCollapsed && !isAboutSubmenuActive()">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item">
              <a [routerLink]="'/contacto'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                Contacto
              </a>
            </li>
            <li class="nav-item">
              <a [routerLink]="'/terminos-condiciones'" class="nav-link text-truncate" routerLinkActive="active" (click)="handleNavigate()">
                Terminos y Condiciones
              </a>
            </li>
          </ul>
        </div>
      </li>
      
      <hr class="sidebar-menu__divider">
      <li class="nav-item">
        <a class="nav-link cursor-pointer" (click)="logout(); handleNavigate()">
          <hugeicons-icon [icon]="LogoutSquare02Icon" color="#ffffff" [size]="20" [strokeWidth]="2" class="nav-icon"></hugeicons-icon>
          Salir
        </a>
      </li>
    </ul>
  </div>
</div>